import React from 'react';

interface ScrollToBottomButtonProps {
	onClick: () => void;
}

export const ScrollToBottomButton: React.FC<ScrollToBottomButtonProps> = ({ onClick }) => (
	<button
		onClick={onClick}
		aria-label="Scroll to bottom"
		style={{
			position: 'absolute',
			bottom: '70px',
			left: '50%',
			transform: 'translateX(-50%)',
			width: '36px',
			height: '36px',
			borderRadius: '50%',
			background: 'linear-gradient(135deg, #1565C0 0%, #42A5F5 100%)',
			border: 'none',
			boxShadow: '0 2px 8px rgba(21, 101, 192, 0.4)',
			cursor: 'pointer',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			zIndex: 5,
			transition: 'opacity 0.2s',
		}}
	>
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
			<path d="M8 3v10M4 9l4 4 4-4" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	</button>
);
